// removed by extract-text-webpack-plugin
module.exports = {"popoverPane":"PopoverPaneWrapper__popoverPane__XAHro","titleBar":"PopoverPaneWrapper__titleBar__199qo","title":"PopoverPaneWrapper__title__3q-38","headerControls":"PopoverPaneWrapper__headerControls__3MQv9","buttonBar":"PopoverPaneWrapper__buttonBar__2d9Gf","nextButton":"PopoverPaneWrapper__nextButton__3K73d"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Popover/PopoverPaneWrapper/PopoverPaneWrapper.scss
// module id = 1734
// module chunks = 0